// Only display the launcher if the user has access to these applications
export const REQUIRED_APPLICATIONS = Object.freeze([
  'plataforma'
]);

// Applications that must always be accessed at the tenant level
// (i.e. the tenant hostname is used instead of the current hostname)
export const TENANT_LEVEL_APPLICATIONS = Object.freeze([
  'customer-center'
]);

// Roles that do not have access to the application launcher
export const BLACKLISTED_ROLES = Object.freeze([
  'student',
  'candidate',
  'basic',
  'resident'
]);

// Applications that do not support operational users
export const NO_OPERATIONAL_USER_APPLICATIONS = Object.freeze([
  'gpa',
  'avalia'
]);
